// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__M-e5K","savePackageButton":"ClientWallet_savePackageButton__3Uw81"};